var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"depressed":"","rounded":"","text":!_vm.boton,"block":_vm.block,"color":_vm.color},on:{"click":function($event){return _vm.logout()}}},[_vm._v(" Cerrar sesión ")])
}
var staticRenderFns = []

export { render, staticRenderFns }